const LoanTrancheModify = () => {
  return (
    <div className="loan-tranche-modify">
      <h1>Placeholder for Loan Tranche Modify</h1>
    </div>
  );
};

export default LoanTrancheModify;
